import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { ButtonProps } from '@/components/ui/button';

interface ActionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  actionLabel: string;
  loadingLabel: string;
  actionVariant?: ButtonProps['variant'];
  onAction: () => Promise<void>;
  loading?: boolean;
}

export function ActionDialog({
  open,
  onOpenChange,
  title,
  description,
  actionLabel,
  loadingLabel,
  actionVariant = 'default',
  onAction,
  loading
}: ActionDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => {
              onOpenChange(false);
            }}
          >
            Cancel
          </Button>
          <Button
            variant={actionVariant}
            onClick={(e) => {
              e.stopPropagation();
              void onAction();
            }}
            disabled={loading}
          >
            {loading ? loadingLabel : actionLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
